import { FC, useState } from 'react';
import arrowRight from 'assets/images/icons/ic_arrow_right.svg';
import ModalityCard, {
  CardType,
} from 'react-components/modalities/modality-card/modality-card';
import styles from './cards.module.scss';
import CareNowProgramsModal from '../care-now-programs/care-now-programs-modal';
import { goTo } from 'router/navigation';
import { ANALYTICS_CONSTANTS } from 'services/google-analytics/constants';
import { AnalyticsEvent } from 'services/google-analytics/analytics-events';
import { getEffectiveSettingsUrl } from 'stores/user-store';
import { programsAll } from 'pages/programs-all/constants';
import {
  isMessageACounsellorOn,
  isFeatureEnabled,
} from 'stores/features-list-store';
import { restrictions } from 'state/features-list/constants';

type Props = {
  type?: keyof typeof CardType;
  shouldGrow?: boolean;
  onClick?: () => void;
};

const goToAllPrograms = () => {
  AnalyticsEvent.Life.Eap.Modalities.GetSupport.clicked(
    ANALYTICS_CONSTANTS.LIFE.EAP.MODALITIES.GETSUPPORT.CLICKED.ITEM_NAME
      .CARENOW,
  );
  goTo(programsAll);
};

const goToCounsellorAssisted = () => {
  const messageACounsellorUrl = getEffectiveSettingsUrl('message_a_counsellor');

  AnalyticsEvent.Life.Eap.Modalities.GetSupport.clicked(
    ANALYTICS_CONSTANTS.LIFE.EAP.MODALITIES.GETSUPPORT.CLICKED.ITEM_NAME
      .CARENOW_COUNSELLOR_ASSISTED,
  );

  window.open(messageACounsellorUrl || '', '_blank', 'noopener noreferrer');
};

const CareNowCard: FC<Props> = ({ type, shouldGrow, onClick }: Props) => {
  const [isCareProgramsOpen, setIsCareProgramsOpen] = useState<boolean>(false);
  const toggleCareProgramsModal = () =>
    setIsCareProgramsOpen(!isCareProgramsOpen);

  const isSelfSignupEnabled = isFeatureEnabled(
    restrictions.digital_programs_self_signup,
  );

  const onSelectProgram = () => {
    if (isMessageACounsellorOn()) {
      return toggleCareProgramsModal();
    }

    goToAllPrograms();

    if (onClick) {
      onClick();
    }
  };

  const showCareNowCard = isMessageACounsellorOn() || isSelfSignupEnabled;

  if (!showCareNowCard) {
    return null;
  }

  return (
    <>
      <ModalityCard
        type={type ?? CardType.primary200}
        title={polyglot.t('care_now.title')}
        info={polyglot.t('care_now.info')}
        shouldGrow={shouldGrow}
      >
        <button className={styles['ghost-btn']} onClick={onSelectProgram}>
          {polyglot.t('care_now.cta')} <img alt='' src={arrowRight} />
        </button>
      </ModalityCard>

      <CareNowProgramsModal
        onCounsellorAssisted={goToCounsellorAssisted}
        onSoloCta={goToAllPrograms}
        onClose={toggleCareProgramsModal}
        isOpen={isCareProgramsOpen}
        isCareNowEnabled={isSelfSignupEnabled}
      />
    </>
  );
};

export default CareNowCard;
